<template lang="pug">
.bg-light
  .container.py-5
    .row.justify-content-center.py-5.register
      .col-md-5
        h3.py-2 Resend the certification letter :
        p.text-primary
          | Please enter your user account, we will resend the verification letter to this account mailbox, thank you
        form(@submit="submitForm")
          .form-group
            label(for="exampleInputEmail1")
              | E-mail(Account Name)
              span.text-danger *
            input#email.form-control(
              type="email",
              v-model="email",
              aria-describedby="emailHelp"
            )
            small please leave the corporate email address.
          .form-group

          .form-group
            button.btn.btn-warning.px-4(type="submit") Send Auth
  float-actions
  float-top
  .PCAP-IC-selector.d-block.d-sm-none
    a.shadow-sm(
      v-b-modal.dialog="",
      @click="$bvModal.show('selectorModal')",
      data-toggle="modal",
      data-target="#selectorModal"
    )
      font-awesome-icon.i_mr_1(:icon="['fas', 'search']") 
      | PCAP IC selector
  custom-footer
</template>

<script>
import Footer from "@/components/home/Footer";
import FloatTop from "@/components/common/FloatTop";
import FloatActions from "@/components/common/FloatActions";
import Vue from "vue";
import { VueReCaptcha } from "vue-recaptcha-v3";
Vue.use(VueReCaptcha, { siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY });
import { resendActivation } from "@/api/user";

export default {
  name: "SendAuth",
  metaInfo() {
    return {
      title: this.metaData.title,
    };
  },
  data() {
    return {
      email: "",

      metaData: {
        title: "Resend Confirmation Letter ｜eGalax_eMPIA Technology Inc.",
      },
    };
  },
  components: {
    "custom-footer": Footer,
    "float-top": FloatTop,
    "float-actions": FloatActions,
  },
  methods: {
    submitForm(e) {
      e.preventDefault();

      let data = {
        email: this.email,
      };

      resendActivation(data).then((response) => {
        console.log(response.data);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
//
</style>
